const shuffleArray = (a) => {
	var j, x, i;
	for(i = a.length - 1; i > 0; i--) {
		j = Math.floor(Math.random() * (i + 1));
		x = a[i];
		a[i] = a[j];
		a[j] = x;
	}
	return a;
};

const is_debug = false;

const getAllWordsByOrientation = (word_positions,orientation) => {
	const selected_words = [];
	const hints = [];

	word_positions.map((word, w) => {
		if(word.orientation != orientation) return;

		let is_hint = false;
		if(hints[`_${w}`] != undefined) is_hint = hints[`_${w}`];

		selected_words.push({
			...word,
			key_index:w + 1,
			is_hint,
		});
	});

	return selected_words.sort((a, b) => {
		return (a.word_index < b.word_index) ? -1 : 1;
	});
};

export const getTwinLetters = (word_positions, board_grid_col) => {
	const letters_arr = [];

	[...Array(board_grid_col).keys()].map((item_x, col) => {
		letters_arr.push([]);

		[...Array(board_grid_col).keys()].map((item_y, row) => {
			letters_arr[col].push(0);
		});
	});

	getAllWordsByOrientation(word_positions,'h').map((word) => {
		const max_x = Math.min(letters_arr.length, parseInt(word.x) + word.word.length);
		for(let i = parseInt(word.x); i < max_x; i++) {
			letters_arr[parseInt(word.y)][i]++;
		}
	});

	getAllWordsByOrientation(word_positions,'v').map((word) => {
		const max_y = Math.min(letters_arr.length, parseInt(word.y) + word.word.length);
		for(let i = parseInt(word.y); i < max_y; i++) {
			letters_arr[i][parseInt(word.x)]++;
		}
	});

	return letters_arr;
};

const checkIfTwin = (twin_letters, row, col) => {
	if(twin_letters[row] == undefined || twin_letters[row][col] == undefined) return 0;
	return parseInt(twin_letters[row][col]);
};

const getNoTwinLettersInWord = (word, twin_letters) => {
	const letters = [];
	
	if(word.orientation == 'h') {
		[...Array(word.word.length).keys()].map((letter, l) => {
			if(checkIfTwin(twin_letters, parseInt(word.y), parseInt(word.x) + l) == 1) {
				letters.push(l);
			}
		});
	} else {
		[...Array(word.word.length).keys()].map((letter, l) => {
			if(checkIfTwin(twin_letters, parseInt(word.y) + l, parseInt(word.x)) == 1) {
				letters.push(l);
			}
		});
	}

	return letters;
};

export const getHints = (word_positions, twins, num_hints) => {
	const _hints = {};
	if(num_hints < 1) return _hints;

	const shuffled_words = shuffleArray([...Array(word_positions.length).keys()]);

	shuffled_words.slice(0, num_hints).map((_word_index) => {
		const word_with_hint = word_positions[_word_index];
		const no_twin_letters = getNoTwinLettersInWord(word_with_hint, twins);
		_hints[`_${_word_index}`] = shuffleArray(no_twin_letters)[0];
	});

	return _hints;
};

const getConnections = (twin, word) => {
	let twins = 0;
	const orientation = word.orientation;
	let start = (orientation == 'h') ? parseInt(word.x) : parseInt(word.y);
	let length = word.word.length;

	for(var i = start; i < start + length; i++) {
		if(orientation == 'h' && twin[parseInt(word.y)][i] == 2) {
			twins++;
		}

		if(orientation == 'v' && twin[i][parseInt(word.x)] == 2) {
			twins++;
		}
	}
	return twins;
}

export const crosswords = (words_obj:object[], size = 5, crossword_positions=undefined) => {
	if(words_obj.length == 0) return [];

	if(crossword_positions != undefined && (words_obj.length == crossword_positions.length+1)) {
		const starting = crossword_positions;
		const clean_words = words_obj.map((w) => {
			return {
				...w,
				subwords:w.word.replace(/\-/g, " ").split(' ').map((w) => w.length),
				word:w.word.toLowerCase().replace(/( |-)/g,""),
				word_index:parseInt(w.word_index)
			}
		});
		const new_word = clean_words.slice(-1);
		const starting_instersections = generateIntersections(clean_words.map((w) => (w.word)),[new_word[0].word]);
		const starting_grid = generateGrid(crossword_positions,size);
		const generated: generatedCrosswords = {
			best:null,
			keys:[],
			all:{}
		}
		const cross = generateCrossWord(starting_instersections, { grid:starting_grid, data:starting}, new_word, generated, { first_only:true });

		if(cross.best) {
			return cross.best.data;
		}
	}

	if(crossword_positions != undefined && (words_obj.length == crossword_positions.length-1)) {
		const twin = getTwinLetters(crossword_positions,size);
		const current_words = words_obj.map(w=>(w.word));
		const deleted_word = crossword_positions.filter(w=>(!current_words.includes(w.word)));

		const connections = getConnections(twin,deleted_word[0]);

		if (connections == 1) {
			return crossword_positions.filter(w=>(w.word != deleted_word[0].word));
		}
	}


	const default_words = [
		{ word:'manzana', definition:"Fruta que cayó del árbol y ayudó a Newtom con la Ley de Gravitación Universal." },
		{ word:'agricola', definition:"Perteneciente o relativo a la agricultura o al agricultor." },
		{ word:'eclipse', definition:"Fenómeno astronómico que sucede cuando un astro se interpone a otro con respecto a un tercero." },
		{ word:'rotulador', definition:"Más grueso que un bolígrafo." },
		{ word:'regalos', definition:"(Plu.) Presente que se hace a otra persona y que suele envolverse con papel de colores llamativos." },
		{ word:'atractivo', definition:"(Masc.) Bonito, estético, proporcionado." },
		{ word:'autobus', definition:"Vehículo de línea grande que sirve para desplazar personas de un punto a otro, normalmente dentro de una misma población." },
		{ word:'motocicleta', definition:"Vechículo motorizado de dos ruedas." },
		{ word:'coche', definition:"Utilitario de cuatro ruedas con una capacidad máxima de 5 pasajeros." },
		{ word:'zapato', definition:"(Sing). Calzado más elegante que unas alpargatas." },
	];

	if(words_obj == undefined) words_obj = default_words;

	const words = words_obj.map((w) => {
		return {
			...w,
			subwords:w.word.replace(/\-/g," ").split(' ').map((w) => w.length),
			word:w.word.toLowerCase().replace(/( |-)/g,"")
		}
	});
	
	const grid = generateEmptyGrid(size);

	const intersections = generateIntersections(words.map((w) => (w.word)));

	const isolated = getIsolated(intersections);
	if (isolated.length > 0) {
		return {status:0,reason:'isolated',isolated};
	}

	const words_by_length = words.sort((a:string, b:string) => {
		return (a.word.length > b.word.length) ? -1 : 1;
	});
	
	const cross = generateCrossWord(intersections, { grid, data:[] }, words_by_length, false, { first_only:true });

	if(cross.best == undefined) {
	
		const all_keys = Object.keys(cross.all);

		for (var i = 0; i < all_keys.length; i++ ) {
			
			const best_effort = cross.all[all_keys[i]][0];
			const present_words = best_effort.data.map(w=>w.word);
			const missing = words_obj.map(w=>w.word).filter((word) => !present_words.includes(word));
			return {status:0,best:cross.all[all_keys[i]][0],missing:missing,time_limit:cross?.time_limit};
		}
	}

	return cross?.best?.data ?? [];
};

type word = {
	word:string;
	x:number;
	y:number;
	orientation:'h'|'v';
}

type crossword = {
	grid:string[][];
	data:word[];
}

type generatedCrosswords = {
	best:crossword | null;
	keys:number[];
	all:{[key:string]:crossword[]}
}

export function generateCrossWord(intersections, cross_word:crossword, words, best:generatedCrosswords | false,config:object,recursive=0,started=Date.now()) {
	let orientation:'h'|'v';
	let x:number;
	let y:number;
	const start = Date.now();
	if(!best) {
		let found_solution = false;
		let final;
		let word = words[0];
		let word_counter = 0;

		do {
			const new_grid = JSON.parse(JSON.stringify(cross_word.grid));
			const { min, crossword, point} = min_intersection(intersections[word.word]);
			
			const remaining = words.filter((w:string) => (w.word != word.word));
			x = 0;
			y = min;
			orientation = 'h';
			placeWord(new_grid, word.word, x, y, orientation);

			const current:crossword = { grid:new_grid, data:[] };
			
			current.data.push({
				...word,
				x,
				y,
				orientation,
				word_index:1
			});

			const generated: generatedCrosswords = {
				best:null,
				keys:[],
				all:{}
			}
		
			final = generateCrossWord(cloneGrid(intersections), current, remaining, generated ,config,recursive+1,start);
			if (final?.best != undefined) {
				found_solution = true;
			}

			if (Date.now()-started > 10000) {
				final.time_limit = true;
				break;
			}

			word_counter++;
			if (words[word_counter] == undefined) {
				break;
			}
			else {
				word = words[word_counter];
			}

		} while (!found_solution);

		return final;
	}

	if(is_debug) console.table(cross_word.grid);

	if (Date.now()-started > 10000) {
		return best; 
	}

	//There are remaining words to be placed
	if (words.length > 0) {

		//For every word in the crossword starting for the first
		for (let i in cross_word.data) {
			const placed_word = cross_word.data[i];

			//For each intersection of this word
			for(let intersection in intersections[placed_word.word].list) {
				//For each intersection at this index
				for(let index in intersections[placed_word.word].list[intersection]) {

					//The intersecting word at this point
					const intersecting = intersections[placed_word.word].list[intersection][index];
					
					const to_remove:number[] = [];

					//Each point that the intersecting word can fit in the placed word
					for(let point_index in intersecting.points) {
						
						const intersecting_point = intersecting.points[point_index];

						const orientation = (placed_word.orientation == 'v') ? 'h' :'v';

						const x = (orientation == 'v') ? parseInt(intersection) + placed_word.x : placed_word.x - intersecting_point;
		
						const y = (orientation == 'v') ? placed_word.y - intersecting_point : placed_word.y + parseInt(intersection);

						//Intersection out of bounds remove from intersections
						if (x < 0 || y < 0) {
							to_remove.push(intersecting_point);
							continue;
						}

						const cloned_crossword = cloneGrid(cross_word);

						const target_grid = cloned_crossword.grid;

						const result = placeWord(target_grid, intersecting.word, x, y, orientation);

						//Word was placed
						if (result) {
						
							const full_word = words.find((w) => (w.word == intersecting.word));

							cloned_crossword.data.push({
								...full_word,
								x,
								y,
								orientation,
								word_index:getWordIndex(x,y, cloned_crossword.data)
							});
							const pruned_intersections = superPrune(intersections,placed_word.word,intersection,intersecting.word,intersecting_point,cloned_crossword.data.map(w=>w.word))
							
							const remaining = words.filter((w:string) => (w.word != intersecting.word));

							if(remaining.length == 0) {
								if(best.all[0] == undefined) best.all[0] = [];
								const finished:crossword = cloned_crossword;
								
								const grid_hash = hash(finished.grid);
								if(best.keys.includes(grid_hash)) {
									continue;
								}

								best.keys.push(grid_hash);
								best.all[0].push(finished);
								if(best.best == undefined) {
									best.best = finished;
								}
								if(config?.first_only) {
									return best;
								}
								continue;
							}

							cloned_crossword.grid = target_grid;
							
							generateCrossWord(pruned_intersections, cloned_crossword, remaining, best, config,recursive+1,started);
						} else {
							to_remove.push(intersecting_point);

							if(best.all[words.length] == undefined) best.all[words.length] = [];

							// if(compareGrids(cross_word.grid,target_grid)) continue;
							const finished:crossword = {grid:target_grid,data:cross_word.data};
							best.all[words.length].push(finished);
						}

						if(config?.first_only && best?.best != undefined) {
							break;
						}
					}

					if (config?.first_only && to_remove.length > 0) {
						//Remove points
						intersections[placed_word.word].list[intersection][index].points = intersections[placed_word.word].list[intersection][index].points.filter(p=>(!to_remove.includes(p)));
						
					}

					if(config?.first_only && best?.best != undefined) {
						break;
					}
				}

				if(config?.first_only && best?.best != undefined) {
					break;
				}
			}

			if(config?.first_only && best?.best != undefined) {
				break;
			}
		}
	}

	return best;
}

function getWordIndex(x, y, data) {
	const word = data.find((word) => (parseInt(word.x) == x && parseInt(word.y) == y));
	if(word) return parseInt(word.word_index);

	let max = 0;
	data.map((word) => {
		word.word_index = parseInt(word.word_index);
		if(word.word_index <= max) return;
		max = word.word_index;
	})

	return max + 1;
}

function cloneGrid(grid) {
	return JSON.parse(JSON.stringify(grid));
}

function compareGrids(grida,gridb) {
	return JSON.stringify(grida) == JSON.stringify(gridb)
}

function min_intersection(word_intersections) {
	if(word_intersections.total == 0) return false;

	let min_intersection = 200;
	let word = "";
	let intersection_point = 0;

	for(let point in word_intersections.list) {
		word_intersections.list[point].map((intersecting_word) => {
			//if(!available.includes(intersecting_word.word)) return;

			const min = Math.min(...intersecting_word.points)
			if(min >= min_intersection) return;
			min_intersection = min;
			word = intersecting_word.word;
			intersection_point = parseInt(point);
		});
	}

	return {
		min:min_intersection,
		crossword:word,
		point:intersection_point,
	};
};

export function generateIntersections(words:string[],only=undefined) {
	const intersections = {}

	words.map((word) => {
		const intersection = {
			total:0,
			list:{},
		};

		const letters = word.split("");

		words.map((intersected) => {
			if(intersected == word) return;

			if(only != undefined && !only.includes(intersected) && !only.includes(word)) return;
			
			const letters_intersected = intersected.split("");

			if(letters.filter((letter) => letters_intersected.includes(letter)).length == 0) {
				return;
			}
			
			for(let i = 0; i < letters.length; i++) {
				if(!letters_intersected.includes(letters[i])) continue;

				if(intersection.list[i] == undefined) intersection.list[i] = [];

				const word_intersections = {
					word:intersected,
					points:[],
				};

				for(let j = 0; j < letters_intersected.length; j++) {
					if(letters_intersected[j] != letters[i]) continue;
					word_intersections.points.push(j);
				}
				intersection.list[i].push(word_intersections);
				intersection.total++;
			}
		});

		intersections[word.toLowerCase()] = intersection;
	});

	return intersections;
};


function getIsolated(intersections) {
	const isolated:string[] = [];
	for (var word in intersections) {
		if (intersections[word].total  != 0) continue;
		isolated.push(word);
	}
	return isolated;
}

export function pruneIntersections(object,word:word) {
	const pruned = {};
	Object.keys(object).map(key=>{

		const list = {};
		for (var index in object[key].list) {
			object[key].list[index].map(intersection => {
				if(intersection.word == word.word) return;
				if(list[index] == undefined) list[index] = [];
				list[index].push(intersection);
			})
		}
		pruned[key] = {list,total:Object.keys(list).length};

	})
	return pruned;
}

function superPrune(object,word:string,word_point,intersecting_word:string,point,placed_words:string[]) {
	const pruned = {};
	// if (placed_words.includes('orangutan') && placed_words.includes('tongo')) {
	// 	debugger;
	// }
	Object.keys(object).map(key=>{
		
		const list = {};
		for (var index in object[key].list) {
			//No more intersections are posible at this index for the word placed
			if (key==word && index == word_point) {
				continue;
			}
			//No more intersections are posible at this index for the word placed
			if (key==intersecting_word && index == point) {
				continue;
			}

			object[key].list[index].map(intersection => {
				if (intersection.points.length == 0) return;
				//Both words will never intersect again
				if (placed_words.includes(key) && placed_words.includes(intersection.word)) return;
				if(list[index] == undefined) list[index] = [];
				list[index].push({...intersection,points:[...intersection.points]});
			})
		}
		pruned[key] = {list,total:Object.keys(list).length};
	})
	return pruned;
}

function hash(grid) {
	var hash = 0, i, chr;
	
	const joined = [];
	grid.map((row) => row.map((symbol) => { joined.push(symbol); }));

	if(joined.length === 0) return hash;
	for(i = 0; i < joined.length; i++) {
		chr = (joined[i] == '') ? " ".charCodeAt(0) : joined[i].charCodeAt(0);
		hash = ((hash << 5) - hash) + chr;
		hash |= 0; // Convert to 32bit integer
	}
	return hash;
}

function generateEmptyGrid(size:number):string[][] {
	const grid = [];
	for(let i = 0; i < size; i++) {
		grid.push([]);
		for(let j = 0; j < size; j++) {
			grid[i].push('');
		}
	}
	return grid;
};

export function generateGrid(word_positions:word[], size=17) {
	const grid = generateEmptyGrid(size);

	word_positions.map((word) => {
		let i = 0;
		if(word.x == undefined || word.y == undefined) return;

		if(word.orientation == 'h') {
			for(let x = 0; x < word.word.length;x++) {
				grid[word.y][parseInt(word.x) + x] = word.word[x];
			}
			return;
		}
		if(word.orientation == 'v') {
			for(let y = 0; y < word.word.length;y++) {
				grid[parseInt(word.y) + y][parseInt(word.x)] = word.word[y];
				i++;
			}
		}
	})
	return grid;
}

export function getGridMinSize(grid:string[][]) {
	let width = 0;
	let height = 0;

	for (let y = 0; y<grid.length; y++) {
		let row_has_letter = false;
		for (let x = 0; x< grid[y].length; x++) {
			if(grid[y][x] == "") continue;
			row_has_letter = true;
			if(x > width) {
				width = x;
			}
		}
		if(row_has_letter && y > height) {
			height = y;
		}
	}
	if(width == 0 && height == 0) return {col:width,row:height}
	return {col:width+1,row:height+1}
}

export function trimGrid(grid:string[][]) {
	const new_grid = [];
	const final_grid = [];
	for (let y = 0; y<grid.length; y++) {
		let row_has_letter = false;
		for (let x = 0; x< grid[y].length; x++) {
			if(grid[y][x] == "") continue;
			row_has_letter = true;
			break;
		}
		if(row_has_letter) {
			new_grid.push(grid[y]);
		}
	}

	for (let x = 0; x<new_grid[0].length; x++) {
		let col_has_letter = false;
		for (let y = 0; y< new_grid.length; y++) {
			if(grid[y][x] == "") continue;
			col_has_letter = true;
			break;
		}
		if(col_has_letter) {
			for (let y = 0; y< new_grid.length; y++) {
				if(final_grid[y] == undefined) final_grid[y] = [];
				final_grid[y].push(new_grid[y][x]);
			}
		}
	}

	return final_grid;
}


export function placeWord(grid:string[][], word:string, x:number, y:number, orientation:'h'|'v') {
	const length = word.length;

	if(x < 0 || y < 0) return false;

	const word_arr = word.split("");

	if(orientation == 'h') {
		let i;
		for(i = 0; i < length; i++) {
			if(!letterIsAllowed(word_arr[i], grid[y][i + x])) return false;
			if(!adjacencyRule(i + x, y, orientation, grid)) return false;
		}

		if((i + x) < grid[y].length && grid[y][i + x] != "") return false;
		if(grid[y][x - 1] != "" && x > 0) return false;

		for(let i = 0; i < length; i++) {
			grid[y][i + x] = word_arr[i]
		}

		return true;
	}

	if(orientation == 'v') {
		let i;
		for(i = 0; i < length; i++) {
			if(i + y >= grid.length) return false;

			if(!letterIsAllowed(word_arr[i], grid[i + y][x])) return false;
			if(!adjacencyRule(x, y + i, orientation, grid)) return false;
		}

		if(i + y < grid.length && grid[i + y][x] !='') return false;
		if(y > 0 && grid[y - 1][x] !='') return false;

		for(let i = 0; i < length; i++) {
			grid[i + y][x] = word_arr[i];
		}
	}

	return true;
};

export function adjacencyRule(x:number, y:number, orientation:'h'|'v', grid) {
	if(grid[y][x] != "") return true;
	if(orientation == 'h') {
		if(y + 1 < grid.length && grid[y + 1][x] != "") return false;
		if(y - 1 > -1 && grid[y - 1][x] != "") return false;
		if(y + 1 >= grid.length) return true;
	}
	if(orientation == 'v') {
		if(x + 1 < grid[y].length && grid[y][x + 1] != "") return false;
		if(x - 1 > -1 && grid[y][x - 1] != "") return false;
		if(x + 1 >= grid[y].length) return true;
	}
	return true;
};

export function letterIsAllowed(letter:string, current:string) {
	if(current == '') return true;
	if(letter == current) return true;
	return false;
};